export default __webpack_public_path__ + "static/media/expl_gradcam_14_DE.42ae1f4b.png";